
import { Box,  Checkbox, Col, FabButton, Flex, Row, } from '../../../ppui';
import { AllowanceBox } from '../../style';
import { formatNumberToFixed } from '../../../utils/common';
import { TbPencil } from 'react-icons/tb';


const OtherAdjustAllowance = ({serviceProps
}) => {

    const {
        setsetAllowancedialogOpen,setAllowance,
        // adjustAllowanceAmount,
        performanceAmount,
        otherAllowanceCalculation,
        employeeEPFInfo,
    }=serviceProps;


    const isEpfEgiliable = employeeEPFInfo?.employeeStatutoryData?.epf_availability;
    const isEsiEgiliable = employeeEPFInfo?.employeeStatutoryData?.esi_availability;
    
  return (
    <> 
 
          <Flex gap={20} direction={"column"}>
        <AllowanceBox >
              <Row alignItems="center">
                <Col xs={"auto"}>
                  <Checkbox 
                  disabled
                    checked
                  color="primary" />
                </Col>
                <Col>
                <Row alignItems="center" gap={{ md: 20, lg: 30, xxl: 60 }}>
                  <Col md={5} xl={4}>
                    <Box className="value">{otherAllowanceCalculation?.allowanceName} allowance</Box>
                    <Box className="value">
                        ₹{formatNumberToFixed(performanceAmount)} {otherAllowanceCalculation?.allowanceType} Amount 
                    </Box>
                  </Col>
                  <Col >
                      <Box className="label">In Gross Wages</Box>
                      <Box className="value" color={otherAllowanceCalculation?.addToGross ? "success" : "danger"}>{otherAllowanceCalculation?.addToGross ? "Included" :"Not Included"}</Box>
                    </Col>
                  {isEsiEgiliable &&

                    <Col >
                      <Box className="label">In ESI Wages</Box>
                      <Box className="value" color={otherAllowanceCalculation?.isEsiWages ? "success" : "danger"}>{otherAllowanceCalculation?.isEsiWages ? "Included" :"Not Included"}</Box>
                    </Col>
}
                    {isEpfEgiliable &&
                    <Col>
                      <Box className="label">In EPF Wages</Box>
                      <Box className="value" color={otherAllowanceCalculation?.isEpfWages ? "success" : "danger"}>{otherAllowanceCalculation?.isEpfWages ? "Included" :"Not Included"}</Box>
                    </Col>
                    }
                  {/* {isEpfEgiliable &&
                  <Col md={5} xl={3}>
                    <Box className="label"  color={(!otherAllowanceCalculation?.isEpfWages && !otherAllowanceCalculation?.isEsiWages) && "danger"}>{(!otherAllowanceCalculation?.isEpfWages && !otherAllowanceCalculation?.isEsiWages) && "Not "} Included in </Box>
                    <Box className="value">{otherAllowanceCalculation?.isEpfWages && "EPF"}{(otherAllowanceCalculation?.isEpfWages && otherAllowanceCalculation?.isEsiWages) && " & "}{otherAllowanceCalculation?.isEsiWages && "ESI"} {(!otherAllowanceCalculation?.isEpfWages && !otherAllowanceCalculation?.isEsiWages) && "EPF & ESI"} wages</Box>
                  </Col>
                  } */}
                  <Col>
                    <Box className="label"> Pay For</Box>
                    <Box className="value">{otherAllowanceCalculation?.noWorkNoPay ? "Present Days" : "Payable Days"}</Box>
                  </Col>
                </Row>
                  
                </Col>
                <Col xs={"auto"}>
                  <Box>
                    <FabButton
                      size="sm"
                      icon={<TbPencil />}
                      onClick={() => {
                        setAllowance({...otherAllowanceCalculation, customId:"adjustAllowanceId",  allowanceValue:formatNumberToFixed(performanceAmount)})
                        setsetAllowancedialogOpen(true)}}
                      variant="filled"
                      shape="box"
                    />
                  </Box>
                </Col>
            
              </Row>
            </AllowanceBox>
    
    
          
          </Flex>
          
         
 
          
          
          </>
  )
}

export default OtherAdjustAllowance
